import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';


import { ConfigServerService, CustomHttp } from '../../../../../core';
import { UsuarioEmailAdministrativo } from '../usuario-email-administrativo';

@Injectable({
    providedIn: 'root'
})
export class UsuarioEmailAdministrativoHttpService {
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/usuario`
    }

    /** Pesquisa os e-mails administrativos cadastrados para o usuário informado */
    search(idUsuario: number): Observable<UsuarioEmailAdministrativo[]> {
        return this.customHttp.get<UsuarioEmailAdministrativo[]>(`${this.pathApi}/${idUsuario}/emailadministrativo`);
    }

    /** Pesquisa os e-mails administrativos cadastrados para o usuário logado */
    searchUsuarioLogado(): Observable<UsuarioEmailAdministrativo[]> {
        return this.customHttp.get<UsuarioEmailAdministrativo[]>(`${this.pathApi}/0/emailadministrativo`);
    }
}
